import { baseURL } from '@/request/http';
import { apiRecipientTpl, apiRecipientUpload } from '@/request/api';
import { saveAsFile } from '@/utils/download';
import withLoading from '@/utils/loading';
import { ElMessage } from 'element-plus';

export default ({ currentGroupId, refresh }) => {

    // 下载模板
    function downloadTemplate() {
        let url = baseURL + apiRecipientTpl();
        url += '?token=' + localStorage.getItem('token');
        saveAsFile(url, '收件人模板-批量上传.xlsx')
    }

    async function handleBatch(file) {
        const formData = new FormData();
        formData.append('file', file.raw);
        formData.append('id', currentGroupId.value);
        const { code } = await withLoading(apiRecipientUpload, { text: '上传中，请稍候...' })(formData);
        if (code !== '0') return;
        ElMessage({ type: 'success', message: '创建成功' });
        refresh();
    }

    return { downloadTemplate, handleBatch }
}